import { useParams } from 'react-router-dom';
import useQueryTypeFromLocation from './useQueryTypeFromLocation';
import useIsCohortAnalysisCheck from './useIsCohortAnalysisCheck';
import { QueryType } from '../apollo/graphqlSchema';
import { assertCondition } from '../types';

const useCohortBuilderIdFromLocation = (): string | undefined => {
  const urlParams = useParams();
  const builderId = urlParams?.builderId;
  const queryType = useQueryTypeFromLocation();
  const isCohortAnalysisPage = useIsCohortAnalysisCheck();

  assertCondition(queryType === QueryType.CohortSample);

  if (builderId && isCohortAnalysisPage) {
    return builderId;
  }
};

export default useCohortBuilderIdFromLocation;
